import * as z from "zod";

import { userSchema } from "./user";

export const boardMeetingConfirmationSchema = z.object({
  user: userSchema,
  confirmedAt: z.coerce.date(),
});

export type BoardMeetingConfirmation = z.infer<
  typeof boardMeetingConfirmationSchema
>;
